<template>
  <div class="formkit-outer border-bottom" />
</template>
